import React from "react";
import { Button } from "react-bootstrap";
import callattend from "../assets/images/callicon.svg";
const { REACT_APP_STATIC_ASSETS_BASE_URL } = process.env;

class AcceptCallButton extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      prepareToReceiveIncomingCall,
      caller,
      shouldDisableButton,
      alterButtonDiableProperty
    } = this.props;
    return (
      <Button
        className="removecolorbut callattendicon"
        onClick={() => {
          alterButtonDiableProperty(true);
          prepareToReceiveIncomingCall(caller);
        }}
        disabled={shouldDisableButton}
      >
        <img alt="" src={`${REACT_APP_STATIC_ASSETS_BASE_URL}${callattend}`} />
      </Button>
    );
  }
}

export default AcceptCallButton;
